<template>
  <v-app>
    <div v-if="userName && !isDemo" class="staging-watermark">STAGING</div>
    <v-main>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </v-main>
  </v-app>
</template>

<script>

import { applyTokens, syncThemeWithUser } from '@/theme'

export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed: {
    userName() {
      return this.$store.getters["settings/userName"];
    },
    isDemo() {
      return this.$store.getters["settings/isDemo"];
    },
    darkMode() {
      return this.$store.getters["settings/darkMode"];
    },
    isStaff() {
      return this.$store.getters["settings/isStaff"];
    },
  },
  watch: {
    isStaff(val) {
      syncThemeWithUser(val, this.$vuetify);
    },
    darkMode(val) {
      this.$vuetify.theme.dark = val;
      applyTokens(val);
    },
  },
  created() {
    this.$vuetify.theme.dark = this.$store.getters["settings/darkMode"];
    applyTokens(this.$vuetify.theme.dark);
  },
};
</script>

<style lang="scss">
.staging-watermark {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 12vw;
  font-weight: 900;
  color: red;
  opacity: 0.1;
  pointer-events: none;
  user-select: none;
  z-index: 9999;
  white-space: nowrap;
}

body {
  background: transparent;
}
.pointer {
  cursor: pointer;
}

// /* Router transitions */
// .fade-enter-active,
// .fade-leave-active {
//   transition: all 0.6s ease;
// }

// .fade-enter {
//   opacity: 0;
//   transform: scale(0.98);
// }

// .fade-leave-to {
//   opacity: 0;
//   transform: scale(1.02);
// }
</style>
